<template>
  <li class="notifications-list-item notifications-list-item--invite" :class="[item.object_type, { removing: removing }]">
    <div @click="openItem()" class="list-item-content" :class="['list-item-content--' + 'unseen']">
      <div class="item-content">
        <div class="item-description">
          <div class="item-description--title">{{ invitationText }}</div>
          <div class="item-description--date">{{ $gettext('Sent on') }} 
            <time :datetime="item.event_time">{{ itemDate }} {{ itemYear }} {{ $gettext('at') }} {{ itemTime }}</time>
          </div>
        </div>
        <div class="item-icon">
          <Avatar v-if="!isAccountant" :user-id="item.created_by" />
          <Avatar v-if="isAccountant && companyProfile" :company-logo="companyProfile" />
        </div>
      </div>
      <div v-if="item.object_type === 'team_invite'" class="notification--btns">
        <button class="notification-btn accept" @click.prevent="acceptInvite">{{ $gettext('Accept') }}</button>
        <button class="notification-btn" @click.prevent="rejectInvite">{{ $gettext('Reject') }}</button>
      </div>
      <LoadingSpinner v-if="loading" :border="false" />
    </div>
  </li>
</template>

<script>
import { mapActions } from "vuex";
import LoadingSpinner from "@/components/dashboard/ui/LoadingSpinner"
import CompanyService from "@/store/services/company.service.js";
import Avatar from "@/components/Avatar";
import moment from 'moment';
export default {
  components: {
    LoadingSpinner, Avatar
  },
  props: {
    item: {
      type: Object,
      default: () => {} 
    }
  },
  data () {
    return {
      loading: false,
      removing: false,
      companyProfile: null
    }
  },
  computed: {
    invitationText () {
      const text = this.item.grammar
                      .replace('%user', this.item.user_name)
                      .replace('%object_type_name', this.item.object_type_name)
                      .replace('%object_name', this.item.object_name)
                      
      return text
    },
    itemTime () {
      return new Date(this.item.event_time).toLocaleTimeString('default', { hour: '2-digit', minute: '2-digit' })
    },
    itemDate () {
      return moment(new Date(this.item.event_time)).format('MMM DD') 
    },
    itemYear () {
      return moment(new Date(this.item.event_time)).format('YYYY') 
    },
    isAccountant () {
      return this.item.object_type === 'accountant_invite'
    }
  },
  mounted () {
    if(this.item.object_type === 'accountant_invite') {
      if (this.item.object_type in this.item && this.item[this.item.object_type]) {
        this.getFreelancerInvite(this.item[this.item.object_type]).then((response) => {
          CompanyService.retrieveAccountant(response.data.accountant).then((response) => {
            this.companyProfile = response.data.company_profile
          })
        })
      }
    }
  },
  methods: {
    ...mapActions({
      acceptInvitation: "notifications/acceptInvite",
      rejectInvitation: "notifications/rejectInvite",
      openModal: "dashboard/openModal",
      getFreelancerInvite: "notifications/getFreelancerInvite"
    }),
    acceptInvite () {
      this.loading = true
      const payload = {
        invite_id: this.item[this.item.object_type],
        user_name: this.item.user_name
      }
      this.acceptInvitation(payload).then(() => {
        this.removing = true
      })
    },
    rejectInvite () {
      this.loading = true
      const payload = {
        invite_id: this.item[this.item.object_type],
        user_name: this.item.user_name
      }
      this.rejectInvitation(payload).then(() => {
        this.removing = true
      })
    },
    openItem () {
      if(this.isAccountant) {
        this.openModal(this.item)
      }
    }
  }
}
</script>

<style lang="scss">
.notifications-list-item--invite {
  $inviteAvatarSize: 45px;
  .avatar {
    width: $inviteAvatarSize;
    height: $inviteAvatarSize;
    min-width: $inviteAvatarSize;
    min-height: $inviteAvatarSize;
    border-radius: 50%;
  }
  .no-avatar {
    font-size: 14px;
    color: #666;
    width: $inviteAvatarSize;
    height: $inviteAvatarSize;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ddd;
    border-radius: 50%;
    padding: 0px;
  }
  .avatar, .no-avatar { margin: 0; padding: 0; margin-left: 7px; }
}

</style>
<style lang="scss" scoped>
  // Base styles for .notifications-list-item on NotificationItem.vue component
  li.notifications-list-item {
    &--invite {
      border-bottom: 1px solid $colorBorderDash;
      // outline: 1px solid $colorBrand;
      // border: 1px solid $colorBrand;
      max-height: 170px;
      overflow: hidden;
      transition: all 0.7s cubic-bezier(0.230, 1.000, 0.320, 1.000);
      padding-bottom: 7px;
      margin-bottom: 5px;
      &.removing {
        max-height: 0px;
        margin: 0;
        padding: 0;
        opacity: 0;
        transform: scale(0.8);
      }

      .list-item-content {
        cursor: initial;
        .item-description {
          margin-left: 0;
        }
      }
      &.accountant_invite {
        .list-item-content {
          cursor: pointer;
        }
      }
      &:hover {
        .list-item-content {
          background: white;
        }
      }
      .notification--btns {
        width: 100%;
        display: flex;
        // justify-content: center;
        // margin-top: 10px;
        margin-top: 7px;
        .notification-btn {
          font-size: 14px;
          padding: 3px 14px;
          border: 1px solid transparent;
          border-radius: 8px;
          transition: all 0.2s ease;
          cursor: pointer;
          &.accept {
            background: $colorBrand;
            color: white;
            &:hover {
              background: darken($colorBrand, 10);
            }
          }
          &:hover {
            background: darken(#efefef, 10);
          }
        }
        .notification-btn:first-child {
          margin-right: 10px;
        }
      }
    }
  }
</style>